(function () {
  const STATES = [
    {
      id: 'or',
      abbr: 'OR',
      name: 'Oregon',
      feesActive: true,
      hasRates: true,
      feesNote: 'Fees active since July 1, 2025',
      checker: {
        thresholds: [
          { type: 'gross_rev_global', amount: 5, effect: 'exempt', desc: 'Under $5M in global gross revenue' },
          { type: 'tonnage', amount: 1, effect: 'exempt', desc: 'Under 1 ton shipped into Oregon' },
        ],
      },
    },
    {
      id: 'co',
      abbr: 'CO',
      name: 'Colorado',
      feesActive: true,
      hasRates: true,
      feesNote: 'Fees active since Jan 1, 2026',
      checker: {
        thresholds: [
          {
            type: 'gross_rev_global',
            amount: 5.5,
            effect: 'exempt',
            desc: 'Under ~$5.5M in global gross revenue (CPI-adjusted)',
          },
          { type: 'tonnage', amount: 1, effect: 'exempt', desc: 'Under 1 ton of covered materials shipped into Colorado' },
        ],
      },
    },
    {
      id: 'ca',
      abbr: 'CA',
      name: 'California',
      feesActive: false,
      hasRates: false,
      feesNote: 'Fees start Jan 1, 2027',
      checker: {
        thresholds: [{ type: 'gross_rev_in_state', amount: 1, effect: 'exempt', desc: 'Under $1M in CA gross sales' }],
      },
    },
    {
      id: 'me',
      abbr: 'ME',
      name: 'Maine',
      feesActive: false,
      hasRates: false,
      feesNote: 'Startup fees late 2026; annual fees Sept 2027',
      checker: {
        thresholds: [{ type: 'gross_rev_global', amount: 2, effect: 'exempt', desc: 'Under $2M in global gross revenue' }],
      },
    },
    {
      id: 'mn',
      abbr: 'MN',
      name: 'Minnesota',
      feesActive: false,
      hasRates: false,
      feesNote: 'Fees not expected until 2028+',
      checker: { thresholds: [] },
    },
    {
      id: 'md',
      abbr: 'MD',
      name: 'Maryland',
      feesActive: false,
      hasRates: false,
      feesNote: 'Fees not expected until 2028+',
      checker: { thresholds: [] },
    },
    {
      id: 'wa',
      abbr: 'WA',
      name: 'Washington',
      feesActive: false,
      hasRates: false,
      feesNote: 'Fees not expected until 2030 (SB 5284 signed May 2025)',
      checker: { thresholds: [] },
    },
  ];

  const OR_RATES = {
    'Recyclable Plastic (PET, HDPE, PP)': { low: 0.09, high: 0.5 },
    'Non-Recyclable Plastic (PS, PVC, film)': { low: 0.43, high: 1.38 },
    'Corrugated Paper / Cardboard': { low: 0.08, high: 0.08 },
    'Paperboard / Cartons': { low: 0.08, high: 0.17 },
    Glass: { low: 0.1, high: 0.1 },
    Aluminum: { low: 0.06, high: 0.24 },
    Steel: { low: 0.1, high: 0.1 },
  };

  const CO_RATES = {
    'Recyclable Plastic (PET, HDPE, PP)': { low: 0.14, high: 0.31 },
    'Non-Recyclable Plastic (PS, PVC, film)': { low: 0.48, high: 1.72 },
    'Corrugated Paper / Cardboard': { low: 0.08, high: 0.08 },
    'Paperboard / Cartons': { low: 0.08, high: 0.13 },
    Glass: { low: 0.04, high: 0.04 },
    Aluminum: { low: 0.02, high: 0.14 },
    Steel: { low: 0.07, high: 0.14 },
  };

  const MATERIALS = Object.keys(OR_RATES);

  const ECOMOD_INFO = {
    or: {
      title: 'Oregon (2026)',
      text: 'Producer-level eco-modulation credits are not yet applied in 2026. The rate difference between recyclable and non-recyclable categories is the mechanism. Recyclable plastics: $0.09–$0.50/lb vs. non-recyclable: $0.43–$1.38/lb. Credits for PCR content and mono-material design are expected to phase in from 2027.',
      source: 'CAA Oregon 2026 Producer Fee Schedule (Oct 29, 2025)',
    },
    co: {
      title: 'Colorado (2026)',
      text: 'Passive eco-modulation is already built into the published 2026 rates: +5% malus for disruptive materials, adjusted rates for non-MRL materials, and -5% bonus for high recycling rates. Already reflected in your estimate above. Colorado also has 4 active incentives producers can certify for.',
      source: 'CAA Colorado 2026 Producer Dues Schedule (Oct 13, 2025)',
    },
  };

  function matKey(mat) {
    return mat.replace(/[^a-z]/gi, '_');
  }

  function getRates(stateId) {
    if (stateId === 'or') return OR_RATES;
    if (stateId === 'co') return CO_RATES;
    const projected = {};
    MATERIALS.forEach((material) => {
      projected[material] = { low: OR_RATES[material].low * 0.5, high: OR_RATES[material].high * 0.5 };
    });
    return projected;
  }

  function initTools(root) {
    const selector = root.querySelector('[data-epr-tools-selector]');
    const reviewLink = root.querySelector('[data-epr-tools-review]');
    const checkerExpanded = root.querySelector('[data-epr-checker-expanded]');
    const calcExpanded = root.querySelector('[data-epr-calc-expanded]');
    const collectionLink = root.dataset.collectionLink || '/collections/all';

    const checker = {
      selectedStates: [],
      role: null,
      packaging: null,
      revBand: null,
      caRevBand: null,
    };

    let calcSelectedStates = [];
    let weightMode = 'known';
    const weights = {};
    const estimates = {};

    const els = {
      checkerGrid: root.querySelector('[data-epr-checker-states]'),
      calcGrid: root.querySelector('[data-epr-calc-states]'),
      cProgressFill: root.querySelector('[data-epr-checker-progress-fill]'),
      cStepLabel: root.querySelector('[data-epr-checker-step-label]'),
      cStepPct: root.querySelector('[data-epr-checker-step-pct]'),
      kProgressFill: root.querySelector('[data-epr-calc-progress-fill]'),
      kStepLabel: root.querySelector('[data-epr-calc-step-label]'),
      kStepPct: root.querySelector('[data-epr-calc-step-pct]'),
      caRevenueWrap: root.querySelector('[data-epr-ca-revenue-wrap]'),
      revenueSel: root.querySelector('[data-epr-revenue]'),
      caRevenueSel: root.querySelector('[data-epr-ca-revenue]'),
      s2Next: root.querySelector('[data-epr-checker-s2-next]'),
      s3Next: root.querySelector('[data-epr-checker-s3-next]'),
      s4Next: root.querySelector('[data-epr-checker-s4-next]'),
      resultPill: root.querySelector('[data-epr-checker-result-pill]'),
      resultTitle: root.querySelector('[data-epr-checker-result-title]'),
      resultBody: root.querySelector('[data-epr-checker-result-body]'),
      stateResults: root.querySelector('[data-epr-checker-state-results]'),
      nextSteps: root.querySelector('[data-epr-checker-next-steps]'),
      nextStepsList: root.querySelector('[data-epr-checker-next-steps-list]'),
      ctaCalc: root.querySelector('[data-epr-checker-cta-calc]'),
      materialsContainer: root.querySelector('[data-epr-calc-materials]'),
      estimateContainer: root.querySelector('[data-epr-estimate-fields]'),
      calcResultsContainer: root.querySelector('[data-epr-calc-results]'),
      calcTotal: root.querySelector('[data-epr-calc-total]'),
      ecomodBoxes: root.querySelector('[data-epr-ecomod-boxes]'),
      ecomodSources: root.querySelector('[data-epr-ecomod-sources]'),
      ecoCta: root.querySelector('[data-epr-eco-cta]'),
      knownMode: root.querySelector('[data-epr-weight-known]'),
      estimateMode: root.querySelector('[data-epr-weight-estimate]'),
    };

    if (els.ecoCta) els.ecoCta.href = collectionLink;

    function scrollToToolTop() {
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
      window.requestAnimationFrame(() => {
        const stickyOffset = 96;
        const top = root.getBoundingClientRect().top + window.pageYOffset - stickyOffset;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      });
    }

    function showExpandedTool(tool) {
      checkerExpanded?.classList.remove('is-visible');
      calcExpanded?.classList.remove('is-visible');

      if (tool === 'checker') {
        checkerExpanded?.classList.add('is-visible');
        renderCheckerStateGrid();
        checkerShowStep(1);
      } else {
        if (checker.selectedStates.length) {
          calcSelectedStates = [...checker.selectedStates];
        }
        calcExpanded?.classList.add('is-visible');
        renderCalcStateGrid();
        calcShowStep(1);
      }

    }

    function openTool(tool) {
      const isSwitchingTools =
        selector?.hidden && (checkerExpanded?.classList.contains('is-visible') || calcExpanded?.classList.contains('is-visible'));

      if (isSwitchingTools) {
        showExpandedTool(tool);
        return;
      }

      if (!selector) return;
      selector.classList.add('is-fading');

      window.setTimeout(() => {
        selector.hidden = true;
        if (reviewLink) reviewLink.hidden = true;
        showExpandedTool(tool);
      }, 220);
    }

    function goBack() {
      checkerExpanded?.classList.remove('is-visible');
      calcExpanded?.classList.remove('is-visible');
      if (!selector) return;
      selector.hidden = false;
      if (reviewLink) reviewLink.hidden = false;
      window.setTimeout(() => selector.classList.remove('is-fading'), 10);
    }

    function renderCheckerStateGrid() {
      if (!els.checkerGrid) return;
      els.checkerGrid.innerHTML = STATES.map(
        (state) => `
          <div
            class="epr-tools__state-tile${checker.selectedStates.includes(state.id) ? ' is-selected' : ''}"
            data-state-id="${state.id}"
            role="button"
            tabindex="0"
            aria-pressed="${checker.selectedStates.includes(state.id)}"
          >
            <span class="abbr">${state.abbr}</span>
            <span class="sname">${state.name}</span>
          </div>
        `
      ).join('');
    }

    function renderCalcStateGrid() {
      if (!els.calcGrid) return;
      els.calcGrid.innerHTML = STATES.map(
        (state) => `
          <div
            class="epr-tools__state-tile${calcSelectedStates.includes(state.id) ? ' is-selected' : ''}${state.hasRates ? '' : ' is-dim'}"
            data-calc-state-id="${state.id}"
            role="button"
            tabindex="0"
            title="${state.feesNote}"
            aria-pressed="${calcSelectedStates.includes(state.id)}"
          >
            <span class="abbr">${state.abbr}</span>
            <span class="sname">${state.name}</span>
            ${state.hasRates ? '' : '<span class="no-rates">Projected</span>'}
          </div>
        `
      ).join('');
    }

    function setCheckerProgress(step) {
      const pct = step <= 4 ? Math.round(((step - 1) / 4) * 100) : 100;
      if (els.cProgressFill) els.cProgressFill.style.width = `${pct}%`;
      if (els.cStepLabel) els.cStepLabel.textContent = step <= 4 ? `Step ${step} of 4` : 'Results';
      if (els.cStepPct) els.cStepPct.textContent = `${pct}%`;
    }

    function checkerShowStep(step) {
      root.querySelectorAll('[data-epr-checker-step]').forEach((panel) => {
        const panelStep = Number(panel.dataset.eprCheckerStep);
        panel.hidden = panelStep !== step;
      });
      setCheckerProgress(step);
    }

    function calcShowStep(step) {
      root.querySelectorAll('[data-epr-calc-step]').forEach((panel) => {
        const panelStep = Number(panel.dataset.eprCalcStep);
        panel.hidden = panelStep !== step;
      });
      const pct = Math.round(((step - 1) / 4) * 100);
      if (els.kProgressFill) els.kProgressFill.style.width = `${pct}%`;
      if (els.kStepLabel) els.kStepLabel.textContent = `Step ${step} of 4`;
      if (els.kStepPct) els.kStepPct.textContent = `${pct}%`;
    }

    function toggleCheckerState(id) {
      const index = checker.selectedStates.indexOf(id);
      if (index >= 0) checker.selectedStates.splice(index, 1);
      else checker.selectedStates.push(id);
      renderCheckerStateGrid();
    }

    function toggleCalcState(id) {
      const index = calcSelectedStates.indexOf(id);
      if (index >= 0) calcSelectedStates.splice(index, 1);
      else calcSelectedStates.push(id);
      renderCalcStateGrid();
    }

    function toggleAllCheckerStates() {
      checker.selectedStates =
        checker.selectedStates.length === STATES.length ? [] : STATES.map((state) => state.id);
      renderCheckerStateGrid();
    }

    function toggleAllCalcStates() {
      calcSelectedStates =
        calcSelectedStates.length === STATES.length ? [] : STATES.map((state) => state.id);
      renderCalcStateGrid();
    }

    function selectRole(value) {
      checker.role = value;
      root.querySelectorAll('[data-epr-checker-role]').forEach((button) => {
        button.classList.toggle('is-selected', button.dataset.value === value);
      });
      if (els.s2Next) els.s2Next.disabled = false;
    }

    function selectPkg(value) {
      checker.packaging = value;
      root.querySelectorAll('[data-epr-checker-packaging]').forEach((button) => {
        button.classList.toggle('is-selected', button.dataset.value === value);
      });
      if (els.s3Next) els.s3Next.disabled = false;
    }

    function checkS4Ready() {
      const needCa = checker.selectedStates.includes('ca');
      const caOk = !needCa || checker.caRevBand !== null;
      if (els.s4Next) els.s4Next.disabled = !(checker.revBand !== null && caOk);
    }

    function evaluateState(state) {
      if (!state?.checker?.thresholds?.length) return 'tbd';
      for (const threshold of state.checker.thresholds) {
        if (threshold.effect !== 'exempt') continue;
        if (threshold.type === 'gross_rev_global' && checker.revBand !== null && checker.revBand < threshold.amount) {
          return 'exempt';
        }
        if (threshold.type === 'gross_rev_in_state' && checker.caRevBand !== null && checker.caRevBand < threshold.amount) {
          return 'exempt';
        }
      }
      return 'covered';
    }

    function renderCheckerResult(verdict, buckets) {
      if (!els.resultPill || !els.resultTitle || !els.resultBody || !els.stateResults) return;

      els.stateResults.innerHTML = '';
      if (els.nextStepsList) els.nextStepsList.innerHTML = '';

      const coveredStates = STATES.filter((state) => buckets?.[state.id] === 'covered');
      const exemptStates = STATES.filter((state) => buckets?.[state.id] === 'exempt');
      const tbdStates = STATES.filter((state) => buckets?.[state.id] === 'tbd');

      if (verdict === 'not_producer') {
        els.resultPill.innerHTML = '<span class="epr-tools__result-verdict">Probably not the producer</span>';
        els.resultTitle.textContent = 'The brand owner is usually the obligated party.';
        els.resultBody.textContent =
          "If you sell wholesale under another brand's label, the retailer typically holds the obligation. Confirm with each retail partner.";
        if (els.nextSteps && els.nextStepsList) {
          els.nextSteps.hidden = false;
          els.nextStepsList.innerHTML = `
            <li>Ask your retail partners whether they have you registered under their producer account.</li>
            <li>If you also sell direct under your own brand, re-run this checker for that channel.</li>
          `;
        }
        if (els.ctaCalc) els.ctaCalc.hidden = true;
      } else if (verdict === 'out_of_scope') {
        els.resultPill.innerHTML = '<span class="epr-tools__result-verdict is-muted">Likely out of scope</span>';
        els.resultTitle.textContent = "If you don't ship covered packaging, you probably don't owe fees.";
        els.resultBody.textContent = 'EPR programs cover packaging on physical goods. Services and digital products are out of scope.';
        if (els.nextSteps && els.nextStepsList) {
          els.nextSteps.hidden = false;
          els.nextStepsList.innerHTML = '<li>Re-check if your business adds physical packaging in the future.</li>';
        }
        if (els.ctaCalc) els.ctaCalc.hidden = true;
      } else {
        if (verdict === 'all_exempt') {
          els.resultPill.innerHTML = '<span class="epr-tools__result-verdict">Likely exempt where you sell</span>';
          els.resultTitle.textContent = 'You appear to be under the exemption threshold in every state you selected.';
          els.resultBody.textContent =
            'Exemptions are not always automatic. Most states still require you to register and document your status.';
        } else if (verdict === 'all_covered') {
          els.resultPill.innerHTML = '<span class="epr-tools__result-verdict">Likely covered everywhere you sell</span>';
          els.resultTitle.textContent = "You're above the exemption threshold in every state you selected.";
          els.resultBody.textContent = 'Open the fee calculator to estimate your annual costs.';
        } else if (verdict === 'all_tbd') {
          els.resultPill.innerHTML = '<span class="epr-tools__result-verdict is-muted">Pending rulemaking</span>';
          els.resultTitle.textContent = "The states you selected haven't finalized their thresholds yet.";
          els.resultBody.textContent =
            "These states have passed EPR laws but haven't published final producer thresholds.";
        } else {
          els.resultPill.innerHTML = '<span class="epr-tools__result-verdict">Mixed — status varies by state</span>';
          els.resultTitle.textContent = 'Your status varies by state.';
          els.resultBody.textContent = '';
        }

        checker.selectedStates.forEach((stateId) => {
          const state = STATES.find((item) => item.id === stateId);
          const bucket = buckets[stateId];
          let reason = '';
          let badge = '';

          if (bucket === 'covered') {
            reason = state.feesNote;
            badge = 'Likely Obligated';
          } else if (bucket === 'exempt') {
            const threshold = state.checker.thresholds.find((item) => item.effect === 'exempt');
            reason = threshold ? threshold.desc : 'Below the exemption threshold.';
            badge = 'Likely Exempt';
          } else {
            reason = `Final thresholds not yet published. ${state.feesNote}`;
            badge = 'TBD';
          }

          const card = document.createElement('div');
          card.className = `epr-tools__state-result is-${bucket}`;
          card.innerHTML = `
            <div class="stripe"></div>
            <div class="body">
              <div class="head">
                <span class="name">${state.name}</span>
                <span class="epr-tools__sr-badge is-${bucket}">${badge}</span>
              </div>
              <div class="reason">${reason}</div>
            </div>
          `;
          els.stateResults.appendChild(card);
        });

        const steps = [];
        if (coveredStates.length) steps.push('Open the fee calculator to estimate your annual costs across covered states.');
        if (exemptStates.length) {
          steps.push('Even if exempt, most states require you to register and document your status with the PRO.');
        }
        if (tbdStates.length) {
          steps.push(`Bookmark this page — we track rulemaking updates for ${tbdStates.map((state) => state.name).join(', ')}.`);
        }

        if (els.nextSteps && els.nextStepsList) {
          els.nextSteps.hidden = steps.length === 0;
          els.nextStepsList.innerHTML = steps.map((step) => `<li>${step}</li>`).join('');
        }

        if (els.ctaCalc) els.ctaCalc.hidden = coveredStates.length === 0;
      }

      checkerShowStep(5);
      scrollToToolTop();
    }

    function showCheckerResult() {
      if (checker.role === 'no') {
        renderCheckerResult('not_producer');
        return;
      }
      if (checker.packaging === 'no') {
        renderCheckerResult('out_of_scope');
        return;
      }

      const buckets = {};
      checker.selectedStates.forEach((stateId) => {
        buckets[stateId] = evaluateState(STATES.find((state) => state.id === stateId));
      });

      const values = Object.values(buckets);
      let verdict;
      if (values.every((value) => value === 'exempt')) verdict = 'all_exempt';
      else if (values.every((value) => value === 'covered')) verdict = 'all_covered';
      else if (values.every((value) => value === 'tbd')) verdict = 'all_tbd';
      else verdict = 'mixed';

      renderCheckerResult(verdict, buckets);
    }

    function checkerRestart() {
      checker.selectedStates = [];
      checker.role = null;
      checker.packaging = null;
      checker.revBand = null;
      checker.caRevBand = null;
      root.querySelectorAll('[data-epr-checker-role], [data-epr-checker-packaging]').forEach((button) => {
        button.classList.remove('is-selected');
      });
      if (els.revenueSel) els.revenueSel.value = '';
      if (els.caRevenueSel) els.caRevenueSel.value = '';
      if (els.s2Next) els.s2Next.disabled = true;
      if (els.s3Next) els.s3Next.disabled = true;
      if (els.s4Next) els.s4Next.disabled = true;
      renderCheckerStateGrid();
      checkerShowStep(1);
    }

    function setWeightMode(mode) {
      weightMode = mode;
      root.querySelectorAll('[data-epr-weight-mode]').forEach((button) => {
        button.classList.toggle('is-active', button.dataset.eprWeightMode === mode);
      });
      if (els.knownMode) els.knownMode.hidden = mode !== 'known';
      if (els.estimateMode) els.estimateMode.hidden = mode !== 'estimate';
    }

    function onWeightInput(stateId, material, value) {
      if (!weights[stateId]) weights[stateId] = {};
      weights[stateId][material] = parseFloat(value) || 0;

      const rates = getRates(stateId)[material];
      const weight = weights[stateId][material];
      const feeEl = root.querySelector(`[data-fee-cell="${stateId}-${matKey(material)}"]`);
      if (feeEl) {
        feeEl.textContent = weight ? `$${Math.round(weight * rates.low)} - $${Math.round(weight * rates.high)}` : '$0';
      }

      let low = 0;
      let high = 0;
      MATERIALS.forEach((mat) => {
        const w = (weights[stateId] && weights[stateId][mat]) || 0;
        low += w * getRates(stateId)[mat].low;
        high += w * getRates(stateId)[mat].high;
      });

      const sectionFee = root.querySelector(`[data-section-fee="${stateId}"]`);
      if (sectionFee) {
        sectionFee.textContent = low || high ? `$${Math.round(low)} - $${Math.round(high)}` : '$0';
      }
    }

    function copyToAll(fromStateId) {
      calcSelectedStates.forEach((stateId) => {
        if (stateId === fromStateId) return;
        weights[stateId] = { ...weights[fromStateId] };
        MATERIALS.forEach((material) => {
          const input = root.querySelector(`[data-weight-input][data-state-id="${stateId}"][data-material="${material}"]`);
          if (input) {
            input.value = weights[stateId][material] || '';
            onWeightInput(stateId, material, weights[stateId][material] || 0);
          }
        });
      });
    }

    function renderMaterialInputs() {
      if (!els.materialsContainer) return;
      els.materialsContainer.innerHTML = '';

      calcSelectedStates.forEach((stateId, index) => {
        const state = STATES.find((item) => item.id === stateId);
        const rates = getRates(stateId);
        if (!weights[stateId]) weights[stateId] = {};

        const section = document.createElement('div');
        section.className = 'epr-tools__state-section';

        const header = document.createElement('button');
        header.type = 'button';
        header.className = 'epr-tools__state-section-header';
        header.innerHTML = `
          <span>${state.name}${state.hasRates ? '' : ' <small style="font-weight:400;color:var(--epr-tools-muted)">(projected rates)</small>'}</span>
          <span class="fee" data-section-fee="${stateId}">$0</span>
        `;

        const body = document.createElement('div');
        body.className = 'epr-tools__state-section-body';

        let rows = MATERIALS.map((material) => {
          const rate = rates[material];
          const rateStr =
            rate.low === rate.high ? `$${rate.low.toFixed(2)}` : `$${rate.low.toFixed(2)} - $${rate.high.toFixed(2)}`;
          const key = matKey(material);
          return `
            <tr>
              <td>${material}</td>
              <td class="rate">${rateStr}/lb</td>
              <td>
                <input
                  type="number"
                  min="0"
                  placeholder="0"
                  value="${weights[stateId][material] || ''}"
                  data-weight-input
                  data-state-id="${stateId}"
                  data-material="${material}"
                  aria-label="${material} pounds in ${state.name}"
                >
              </td>
              <td class="cost" data-fee-cell="${stateId}-${key}">$0</td>
            </tr>
          `;
        }).join('');

        body.innerHTML = `
          <table class="epr-tools__material-table">
            <thead>
              <tr>
                <th>Material</th>
                <th>Rate per lb</th>
                <th>Weight (lbs)</th>
                <th style="text-align:right">Est. fee</th>
              </tr>
            </thead>
            <tbody>${rows}</tbody>
          </table>
          <span class="epr-tools__copy-link" data-copy-weights="${stateId}">Copy these weights to other states</span>
        `;

        header.addEventListener('click', () => {
          body.hidden = !body.hidden;
        });

        section.appendChild(header);
        section.appendChild(body);
        els.materialsContainer.appendChild(section);

        MATERIALS.forEach((material) => {
          const input = body.querySelector(`[data-weight-input="${stateId}-${matKey(material)}"]`);
          if (input?.value) onWeightInput(stateId, material, input.value);
        });
      });
    }

    function renderEstimateInputs() {
      if (!els.estimateContainer) return;
      els.estimateContainer.innerHTML = calcSelectedStates
        .map((stateId) => {
          const state = STATES.find((item) => item.id === stateId);
          return `
            <div class="epr-tools__estimate-field">
              <label>Annual packaging spend in ${state.name} (USD)</label>
              <input
                type="number"
                min="0"
                placeholder="e.g. 50000"
                value="${estimates[stateId] || ''}"
                data-estimate-input="${stateId}"
                aria-label="Annual packaging spend in ${state.name}"
              >
              <div class="hint">Estimate what you spend buying packaging for products sold into ${state.name}.</div>
            </div>
          `;
        })
        .join('');
    }

    function collectWeights() {
      if (weightMode !== 'estimate') return;
      calcSelectedStates.forEach((stateId) => {
        const spend = estimates[stateId] || 0;
        const lbs = spend / 0.5;
        if (!weights[stateId]) weights[stateId] = {};
        const mix = [0.3, 0.1, 0.3, 0.15, 0.05, 0.05, 0.05];
        MATERIALS.forEach((material, index) => {
          weights[stateId][material] = lbs * mix[index];
        });
      });
    }

    function renderCalcResults() {
      if (!els.calcResultsContainer || !els.calcTotal) return;
      els.calcResultsContainer.innerHTML = '';

      let totalLow = 0;
      let totalHigh = 0;

      calcSelectedStates.forEach((stateId) => {
        const state = STATES.find((item) => item.id === stateId);
        const rates = getRates(stateId);
        let stateLow = 0;
        let stateHigh = 0;
        const matLines = [];

        MATERIALS.forEach((material) => {
          const weight = (weights[stateId] && weights[stateId][material]) || 0;
          if (!weight) return;
          stateLow += weight * rates[material].low;
          stateHigh += weight * rates[material].high;
          matLines.push({
            material,
            weight,
            feeLow: Math.round(weight * rates[material].low),
            feeHigh: Math.round(weight * rates[material].high),
          });
        });

        totalLow += stateLow;
        totalHigh += stateHigh;

        let badgeClass;
        let badgeLabel;
        if (state.hasRates && state.feesActive) {
          badgeClass = 'is-active';
          badgeLabel = 'Fees active';
        } else if (state.id === 'ca') {
          badgeClass = 'is-reporting';
          badgeLabel = 'Reporting now';
        } else {
          badgeClass = 'is-tbd';
          badgeLabel = state.feesActive ? 'Active' : 'No rates yet';
        }

        const hasFee = stateLow > 0 || stateHigh > 0;
        const feeText = hasFee
          ? `$${Math.round(stateLow).toLocaleString()} - $${Math.round(stateHigh).toLocaleString()}/yr`
          : 'No weight entered';
        const noteText = state.hasRates ? 'Published CAA 2026 rates.' : state.feesNote || 'Rates not yet published.';

        const rows =
          matLines
            .map(
              (line) => `
                <div class="epr-tools__fsc-row">
                  <span>${line.material} (${line.weight.toFixed(0)} lbs)</span>
                  <span>$${line.feeLow.toLocaleString()} - $${line.feeHigh.toLocaleString()}</span>
                </div>
              `
            )
            .join('') ||
          '<div style="font-size:1.3rem;color:var(--epr-tools-muted);padding:0.4rem 0">No weights entered.</div>';

        const card = document.createElement('div');
        card.className = 'epr-tools__fee-card';
        card.innerHTML = `
          <div class="epr-tools__fee-card-head">
            <span class="epr-tools__fee-card-name">${state.name}</span>
            <div class="epr-tools__fee-card-right">
              <span class="epr-tools__fsc-badge ${badgeClass}">${badgeLabel}</span>
              <span class="epr-tools__fee-amount${hasFee ? '' : ' is-zero'}">${feeText}</span>
            </div>
          </div>
          <div class="epr-tools__fee-note">${noteText}</div>
          <div class="epr-tools__fee-breakdown">${rows}</div>
        `;
        els.calcResultsContainer.appendChild(card);
      });

      els.calcTotal.textContent =
        totalLow || totalHigh
          ? `$${Math.round(totalLow).toLocaleString()} - $${Math.round(totalHigh).toLocaleString()}`
          : '$0';
    }

    function renderEcoModStep() {
      if (!els.ecomodBoxes || !els.ecomodSources) return;
      els.ecomodBoxes.innerHTML = '';

      const activeStates = calcSelectedStates.filter((stateId) => ECOMOD_INFO[stateId]);
      const otherStates = calcSelectedStates.filter((stateId) => !ECOMOD_INFO[stateId]);
      const sources = [];

      activeStates.forEach((stateId) => {
        const info = ECOMOD_INFO[stateId];
        const box = document.createElement('div');
        box.className = 'epr-tools__eco-box';
        box.innerHTML = `<h3>${info.title}</h3><p>${info.text}</p>`;
        els.ecomodBoxes.appendChild(box);
        sources.push(info.source);
      });

      if (otherStates.length) {
        const names = otherStates.map((stateId) => STATES.find((state) => state.id === stateId)?.name).filter(Boolean).join(', ');
        const box = document.createElement('div');
        box.className = 'epr-tools__eco-box';
        box.innerHTML = `
          <h3>${names}</h3>
          <p>Fee rates and eco-modulation rules for these states are not yet published. When final rules are released, the same principle applies: materials classified as recyclable will carry lower fees than non-recyclable equivalents.</p>
        `;
        els.ecomodBoxes.appendChild(box);
      }

      els.ecomodSources.textContent = sources.length ? `Sources: ${sources.join(' and ')}.` : '';
    }

    function calcRestart() {
      calcSelectedStates = [];
      Object.keys(weights).forEach((key) => delete weights[key]);
      Object.keys(estimates).forEach((key) => delete estimates[key]);
      renderCalcStateGrid();
      calcShowStep(1);
    }

    root.addEventListener('click', (event) => {
      const target = event.target.closest('[data-epr-open-tool]');
      if (target) {
        openTool(target.dataset.eprOpenTool);
        return;
      }

      if (event.target.closest('[data-epr-tools-back]')) {
        goBack();
        return;
      }

      if (event.target.closest('[data-epr-checker-select-all]')) {
        toggleAllCheckerStates();
        return;
      }

      if (event.target.closest('[data-epr-calc-select-all]')) {
        toggleAllCalcStates();
        return;
      }

      const checkerTile = event.target.closest('[data-state-id]');
      if (checkerTile) {
        toggleCheckerState(checkerTile.dataset.stateId);
        return;
      }

      const calcTile = event.target.closest('[data-calc-state-id]');
      if (calcTile) {
        toggleCalcState(calcTile.dataset.calcStateId);
        return;
      }

      const roleBtn = event.target.closest('[data-epr-checker-role]');
      if (roleBtn) {
        selectRole(roleBtn.dataset.value);
        return;
      }

      const pkgBtn = event.target.closest('[data-epr-checker-packaging]');
      if (pkgBtn) {
        selectPkg(pkgBtn.dataset.value);
        return;
      }

      const weightModeBtn = event.target.closest('[data-epr-weight-mode]');
      if (weightModeBtn) {
        setWeightMode(weightModeBtn.dataset.eprWeightMode);
        return;
      }

      const copyBtn = event.target.closest('[data-copy-weights]');
      if (copyBtn) {
        copyToAll(copyBtn.dataset.copyWeights);
        return;
      }

      const checkerNext = event.target.closest('[data-epr-checker-next]');
      if (checkerNext) {
        const step = Number(checkerNext.dataset.eprCheckerNext);
        if (step === 1) {
          if (!checker.selectedStates.length) {
            window.alert('Please select at least one state.');
            return;
          }
          checkerShowStep(2);
        } else if (step === 2) {
          if (!checker.role) return;
          if (checker.role === 'no') {
            showCheckerResult();
            return;
          }
          checkerShowStep(3);
        } else if (step === 3) {
          if (!checker.packaging) return;
          if (checker.packaging === 'no') {
            showCheckerResult();
            return;
          }
          if (els.caRevenueWrap) {
            els.caRevenueWrap.hidden = !checker.selectedStates.includes('ca');
          }
          checkerShowStep(4);
        }
        return;
      }

      const checkerBack = event.target.closest('[data-epr-checker-back]');
      if (checkerBack) {
        checkerShowStep(Number(checkerBack.dataset.eprCheckerBack));
        return;
      }

      if (event.target.closest('[data-epr-checker-evaluate]')) {
        showCheckerResult();
        return;
      }

      if (event.target.closest('[data-epr-checker-restart]')) {
        checkerRestart();
        return;
      }

      const calcNext = event.target.closest('[data-epr-calc-next]');
      if (calcNext) {
        const step = Number(calcNext.dataset.eprCalcNext);
        if (step === 1) {
          if (!calcSelectedStates.length) {
            window.alert('Please select at least one state.');
            return;
          }
          renderMaterialInputs();
          renderEstimateInputs();
          calcShowStep(2);
        } else if (step === 2) {
          collectWeights();
          renderCalcResults();
          calcShowStep(3);
          scrollToToolTop();
        } else if (step === 3) {
          renderEcoModStep();
          calcShowStep(4);
          scrollToToolTop();
        }
        return;
      }

      const calcBack = event.target.closest('[data-epr-calc-back]');
      if (calcBack) {
        calcShowStep(Number(calcBack.dataset.eprCalcBack));
        return;
      }

      if (event.target.closest('[data-epr-calc-restart]')) {
        calcRestart();
      }
    });

    root.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const checkerTile = event.target.closest('[data-state-id]');
      if (checkerTile) {
        event.preventDefault();
        toggleCheckerState(checkerTile.dataset.stateId);
        return;
      }
      const calcTile = event.target.closest('[data-calc-state-id]');
      if (calcTile) {
        event.preventDefault();
        toggleCalcState(calcTile.dataset.calcStateId);
      }
    });

    root.addEventListener('change', (event) => {
      if (event.target.matches('[data-epr-revenue]')) {
        checker.revBand = parseFloat(event.target.value) || null;
        checkS4Ready();
      }
      if (event.target.matches('[data-epr-ca-revenue]')) {
        checker.caRevBand = parseFloat(event.target.value) || null;
        checkS4Ready();
      }
    });

    root.addEventListener('input', (event) => {
      const estimateInput = event.target.closest('[data-estimate-input]');
      if (estimateInput) {
        estimates[estimateInput.dataset.estimateInput] = parseFloat(estimateInput.value) || 0;
        return;
      }

      const weightInput = event.target.closest('[data-weight-input]');
      if (weightInput?.dataset.stateId && weightInput.dataset.material) {
        onWeightInput(weightInput.dataset.stateId, weightInput.dataset.material, weightInput.value);
      }
    });

    renderCheckerStateGrid();
    renderCalcStateGrid();
  }

  function initialize(scope) {
    scope.querySelectorAll('[data-epr-tools]').forEach((root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      initTools(root);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initialize(document));
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
